import { FCWithChildren } from '@types';
import React from 'react';
import { Button, Modal, ModalBody } from '@components';
import useLayoutContext from '@hooks/useLayoutContext';

type ModalThankYouGuestProps = {
  isOpen: boolean;
  onClose: () => void;
  expiry: string;
};

const ModalThankYouGuest: FCWithChildren<ModalThankYouGuestProps> = ({
  isOpen,
  onClose,
  expiry = '',
}) => {
  const { isCaptivePortal, loginToCaptivePortal } = useLayoutContext();
  return (
    <Modal closeModal={onClose} isOpen={isOpen}>
      <ModalBody>
        {isCaptivePortal ? (
          <div>
            <div className="border rounded-[10px] my-5 p-5 border-red-700 bg-red-200 text-red-800 text-lg">
              <div className="flex gap-3 items-center">
                <div>Click connect device to get internet access.</div>
              </div>
            </div>
            <Button
              onClick={() => {
                loginToCaptivePortal();
              }}
            >
              Connect Device
            </Button>
          </div>
        ) : (
          <>
            <div className="mb-2 text-center">
              <h2 style={{ fontSize: '125%' }} className="pb-5">
                Thank You!
              </h2>
            </div>
            <div className="mb-5">
              <p>Your Guest Account has been created and this device is now online!</p>
            </div>
            <div className="mb-5">
              <p>Guest access will expire on {expiry}.</p>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalThankYouGuest;
